module.exports = __webpack_public_path__ + "static/media/gaming11.22d54a58.webp";